import { mapKeys, camelCase } from 'lodash';

export default function instanceEvents(instance) {
  return mapKeys(instance.$listeners, (listener, key) => camelCase(key));
}
